/**
 * Created by lenovo on 2017/3/3.
 */
var moment = require('moment');
////得到某一日期的前一天 后一天 n可以正负数
export function dateAdd(dd,n){
    var strs= new Array();
    strs = dd.split("-");
    var y = strs[0];
    var m = strs[1];
    var d = strs[2];
    var t = new Date(y,m-1,d);
    var str = t.getTime()+n*(1000*60*60*24);
    var newdate = new Date();
    newdate.setTime(str);
    var strYear=newdate.getFullYear();
    var strDay=newdate.getDate();
    if(strDay < 10){
        strDay = "0"+strDay;
    }
    var strMonth=newdate.getMonth()+1;
    if(strMonth < 10){
        strMonth = "0"+strMonth;
    }
    var strdate=strYear+"-"+strMonth+"-"+strDay;
    return strdate;
}
//当天日期的前一天 后一天 n可以正负数
export function GetDateStr(AddDayCount) {
    var dd = new Date();
    dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
    var y = dd.getFullYear();
    var m = dd.getMonth()+1;//获取当前月份的日期
    m = m < 10 ? '0' + m : m;
    var d = dd.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y+"-"+m+"-"+d;
}

//获取当前时间
export function getNowFormatDate() {
    var date = new Date();
    var seperator1 = "-";
    var seperator2 = ":";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
        + " " + date.getHours() + seperator2 + date.getMinutes()
        + seperator2 + date.getSeconds();
    return currentdate;
}
//时间戳转时间
function add0(m){return m<10?'0'+m:m }
export function timesTampsToData(timesTamps) {
    var time = new Date(timesTamps);
    var y = time.getFullYear();
    var m = time.getMonth()+1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
}
//时间转时间戳
export function timestamp() {
    var timestamp = Date.parse(new Date());
    timestamp = timestamp / 1000;
    return timestamp
}
export function timesTamp(y,m,d) {
    var date = new Date(y,m-1,d);
    return (date.getTime());
}
export  function returnDate(time) {
    var returnTime = time == null?"":moment.unix(time/1000).format("YYYY-MM-DD HH:mm:ss");
    return returnTime;
}
//检查所有的input是否为空
export function checkInput(){
    var check =true;
    var m=document.getElementsByTagName("input");
    for(var i=0;i<m.length;i++)
    {
        if(m[i].value==""||m[i].value==null)
        {
            check = false;
        }
    }
    return check
}
export function mapToJSON(map) {
    const json = [];
    for(var key in map){
        json.push({"id":key,"name":map[key]})
    }
    return json;
}



// WEBPACK FOOTER //
// ./modules/function.js